import { createPermission } from '@backstage/plugin-permission-common';

/**
 * @public
 */
export const updateCheckAnalysisPermission = createPermission({
  name: 'updatecheck.analysis',
  attributes: { action: 'read' },
});

// frontend.updatecheck was moved from frontend-permissions-backend to here because it belongs to the update check
// TODO The name "frontend.updatecheck" should be renamed to the format "updatecheck.*" but previously possible references should be checked
/**
 * @public
 */
export const frontendUpdateCheckPermission = createPermission({
  name: 'frontend.updatecheck',
  attributes: { action: 'read' },
});

/**
 * List of all update check permissions
 *
 * @public
 */
export const updateCheckPermissions = [
  updateCheckAnalysisPermission,
  frontendUpdateCheckPermission
];

